// Placeholder rotating entries for the hero's "live activity" notification —
// swap for real traveler data once we have a feed to pull from. Headlines
// are kept to a short "{name} saved ${amount} in {city}!" template
// (verified to fit on one line at the widget's mobile width without
// wrapping or truncating) — lengthen this template only after re-checking
// that fit on a narrow phone viewport.
export const LIVE_FEED_ITEMS = [
  {
    headline: "Theo saved $184 in Paris!",
    timestamp: "3 hours ago",
    body: "Good news: Gondola found a better rate and updated the stay. Same room and perks, now with extra savings.",
  },
  {
    headline: "Nina saved $212 in Miami!",
    timestamp: "just now",
    body: "Good news: Gondola found a better rate and updated the flight. Same seat and perks, now with extra savings.",
  },
  {
    headline: "Liam saved $53 in Tokyo!",
    timestamp: "2 hours ago",
    body: "Good news: Gondola found a better rate and updated the trip. Same car and perks, now with extra savings.",
  },
  {
    headline: "Maya saved $142 in Dubai!",
    timestamp: "45 min ago",
    body: "Good news: Gondola found a better rate and updated the stay. Same room and perks, now with extra savings.",
  },
  {
    headline: "Omar saved $268 in Rome!",
    timestamp: "just now",
    body: "Good news: Gondola found a better rate and updated the flight. Same seat and perks, now with extra savings.",
  },
  {
    headline: "Zara saved $61 in Milan!",
    timestamp: "1 hour ago",
    body: "Good news: Gondola found a better rate and updated the trip. Same car and perks, now with extra savings.",
  },
  {
    headline: "Iris saved $317 in Sydney!",
    timestamp: "20 min ago",
    body: "Good news: Gondola found a better rate and updated the stay. Same room and perks, now with extra savings.",
  },
  {
    headline: "Kofi saved $198 in Cairo!",
    timestamp: "3 hours ago",
    body: "Good news: Gondola found a better rate and updated the flight. Same seat and perks, now with extra savings.",
  },
  {
    headline: "Anna saved $95 in Vegas!",
    timestamp: "just now",
    body: "Good news: Gondola found a better rate and updated the stay. Same room and perks, now with extra savings.",
  },
  {
    headline: "Owen saved $44 in Seoul!",
    timestamp: "10 min ago",
    body: "Good news: Gondola found a better rate and updated the trip. Same car and perks, now with extra savings.",
  },
  {
    headline: "Ravi saved $126 in London!",
    timestamp: "2 hours ago",
    body: "Good news: Gondola found a better rate and updated the stay. Same room and perks, now with extra savings.",
  },
  {
    headline: "Ella saved $233 in Berlin!",
    timestamp: "just now",
    body: "Good news: Gondola found a better rate and updated the flight. Same seat and perks, now with extra savings.",
  },
  {
    headline: "Amir saved $88 in Madrid!",
    timestamp: "1 hour ago",
    body: "Good news: Gondola found a better rate and updated the stay. Same room and perks, now with extra savings.",
  },
  {
    headline: "Leo saved $57 in Athens!",
    timestamp: "30 min ago",
    body: "Good news: Gondola found a better rate and updated the trip. Same car and perks, now with extra savings.",
  },
  {
    headline: "Yuki saved $221 in Vienna!",
    timestamp: "3 hours ago",
    body: "Good news: Gondola found a better rate and updated the stay. Same room and perks, now with extra savings.",
  },
  {
    headline: "Nora saved $175 in Prague!",
    timestamp: "just now",
    body: "Good news: Gondola found a better rate and updated the flight. Same seat and perks, now with extra savings.",
  },
  {
    headline: "Kai saved $109 in Dublin!",
    timestamp: "50 min ago",
    body: "Good news: Gondola found a better rate and updated the stay. Same room and perks, now with extra savings.",
  },
  {
    headline: "Mia saved $64 in Denver!",
    timestamp: "2 hours ago",
    body: "Good news: Gondola found a better rate and updated the trip. Same car and perks, now with extra savings.",
  },
];

export const LIVE_FEED_INTERVAL = 4000;
export const LIVE_FEED_TRANSITION = 400;
